import React, {Component} from 'react';
import { Button, Form, Message } from 'semantic-ui-react'
import {client} from '../../Client';
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'
import Moment from 'moment'
import {Redirect} from 'react-router-dom';
import 'react-date-picker/index.css'
import {convertNullToEmptyString, arrayToCombo} from '../../Helpers'
import TestiEditDropdown from '../TestiEditDropdown'
import PropTypes from 'prop-types';
import ErrorMessage from '../ErrorMessage'

class AttivitaForm extends Component {
    constructor(props) {
        super(props);
        let fields = convertNullToEmptyString(props.item);
        if (fields["inizio"]){
            fields["inizio"] = Moment(fields["inizio"]).format("HH:mm");
        }
        if (fields["fine"]){
            fields["fine"] = Moment(fields["fine"]).format("HH:mm");
        }
        if (fields["idCommessa"]){
            fields["idCommessa"] = fields["idCommessa"].idCommessa;
        }

        this.state = {
            attivita: props.item,
            fields: fields,
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            error: null,
            dropdownNotaLoading: false,
            dropdownCommesseLoading: false,
            commesseList: arrayToCombo(props.commesseList, "idCommessa", "nomeCompleto", "idCommessa"),
        };
        this.onSaveClick = this.onSaveClick.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.formIsValid = this.formIsValid.bind(this)
        this.isLoadingInProgress = this.isLoadingInProgress.bind(this)
        this.onDDNotaLoading = this.onDDNotaLoading.bind(this)
        this.onDeleteClick = this.onDeleteClick.bind(this)
    }

    componentDidMount(){
    }

    onSaveClick(attivita) {
        if (this.props.onSaveClick)
        {
            this.props.onSaveClick(attivita);
        }
    }

    formIsValid(formData) {
        // Validazione dati
        let fieldErrorsText = []
        let fieldErrors = {}

        // Inserire validazioni
        // ...

        if (this.state.fields.inizio !== undefined && this.state.fields.fine !== undefined && this.state.fields.inizio > this.state.fields.fine)
        {
            fieldErrors["fine"] = true;
            fieldErrorsText.push("Occorre specificare un'ora di fine uguale o superiore a quella di inizio");
        }


        if (Object.keys(fieldErrors).length > 0)
        {
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle:"La form contiene errori",
                inError: true
            })
            return false;
        }
        return true;
    }

    onInputChange(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            let prevValue = fields[name];
            fields[name] = value;
            if (name === 'fine' || name === 'inizio'){

                if (value.length === 2 && !value.includes(':')){
                    if (prevValue.length === 3 && prevValue.includes(':')){
                        fields[name] = '';
                    }
                    else
                    {
                        fields[name] += ':';
                    }
                }
            }
            this.setState({ fields, fieldErrors: {}, fieldErrorsText:[], errorTitle:'', inError: false });
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        let formData = Object.assign({}, this.state.fields);

        // Validazione form
        if (!this.formIsValid(this.state.fields)){
            return;
        }
        formData["inizio"] = this.props.giorno + " " + formData["inizio"];
        formData["fine"] = this.props.giorno + " " + formData["fine"];
        formData["idCommessa"] = this.state.fields.idCommessa;
        formData["idUtente"] = this.state.fields.idUtente.idUtente;

        this.setState({_loading: true});
        client.saveAttivita(
            formData, this.state.fields.idAttivita
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        // saveSuccess: true,
                        // attivitaSaved: data,
                    });
                    this.onSaveClick(data);
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    onDeleteClick(){

    }

    isLoadingInProgress(){
        return this.state._loading || this.state.dropdownNotaLoading || this.dropdownCommesseLoading;
    }

    onDDNotaLoading(value){
        this.setState({dropdownNotaLoading: value})
    }

    handleCancel(e){
        e.preventDefault();
        this.props.onUndoClick(e)
    }

    onOraAttualeClick(ev, fieldName) {
        console.log("ORA ATTUALE")
        ev.preventDefault();
        let fields = Object.assign({}, this.state.fields);
        fields[fieldName] = Moment().format("HH:mm");
        this.setState({fields})
    }

    render() {
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let formInError = this.state.fieldErrorsText.length > 0;

        if (this.state.saveSuccess || this.state.cancelSuccess){
            return <Redirect to={ {
                pathname: '/app/attivita',
                state: {
                    from: this.props.location,
                    item: this.state.attivitaSaved,
                },
            }}/>
        }

        return <div>
            <p>Registrazione attività su <b>{this.props.item.idCommessa.nomeCompleto}</b> per il giorno <b><LocalDate data={this.props.giorno} inline /></b> iniziata alle ore <b><LocalTime data={this.props.item.inizio} /></b>.</p>

            <Form onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>

                <Form.Group>
                    <Form.Input label='Ora inizio' name='inizio'  pattern="^[0-9]{1,2}:[0-9]{1,2}$" autoComplete="nope" required={true}  value={this.state.fields.inizio} error={this.state.fieldErrors["inizio"]} onChange={this.onInputChange}/>
                    <Form.Field>
                        <label>&nbsp;</label>
                        <Button type='button' loading={this.isLoadingInProgress()} onClick={(ev) => this.onOraAttualeClick(ev, "inizio")}><i className="clock icon"/> Ora</Button>
                    </Form.Field>
                    <Form.Input label='Ora fine' name='fine'  pattern="^[0-9]{1,2}:[0-9]{1,2}$" autoComplete="nope" required={true}  value={this.state.fields.fine} error={this.state.fieldErrors["fine"]} onChange={this.onInputChange}/>
                    <Form.Field>
                        <label>&nbsp;</label>
                        <Button type='button' loading={this.isLoadingInProgress()} onClick={(ev) => this.onOraAttualeClick(ev, "fine")}><i className="clock icon"/> Ora</Button>
                    </Form.Field>
                    <Form.Field width={4}>
                        <label>Peso</label>
                        <Form.Group inline>
                        <Form.Input style={{width:"50px"}}  name='peson' min="1" max="10" placeholder='' autoComplete="nope"  value={this.state.fields.peson} onChange={this.onInputChange}/>&nbsp;/&nbsp;&nbsp;
                        <Form.Input style={{width:"50px"}} name='pesod' min="1" max="10" placeholder='' autoComplete="nope"  value={this.state.fields.pesod} onChange={this.onInputChange}/>
                        </Form.Group>
                    </Form.Field>
                </Form.Group>
                <Form.Dropdown width={16} loading={this.state.dropdownCommesseLoading} placeholder='Commessa' name='idCommessa' fluid search selection options={this.state.commesseList} value={this.state.fields.idCommessa}
                               onChange={this.onInputChange} error={this.state.fieldErrors["idCommessa"]} />
                <TestiEditDropdown tipo="ATTNT" name='nota' additionLabel='Note: '
                                   placeholder="Note..."
                                   maxlength={255}
                                   value={''+this.state.fields.nota}
                                   error={this.state.fieldErrors["nota"]}
                                   onChange={this.onInputChange}
                                   onLoading={this.onDDNotaLoading}
                />

                <Form.Group inline>
                    <Button type='button' loading={this.isLoadingInProgress()} onClick={(ev) => this.handleCancel(ev)}><i className="undo icon"/> Annulla</Button>
                    <Button primary type='submit' loading={this.isLoadingInProgress()}><i className="save icon"/> Salva</Button>
                </Form.Group>

                <Message
                    error
                    header={this.state.errorTitle}
                    list={this.state.fieldErrorsText}
                />
                <Message
                    success
                    header={this.state.successTitle}
                    content={this.state.successText}
                    icon={"smile"}
                />

            </Form>

        </div>
    }
}

AttivitaForm.PropTypes = {
    item: PropTypes.object.isRequired,
    giorno: PropTypes.string.isRequired,
    commesseList: PropTypes.array.isRequired,
    onUndoClick: PropTypes.func.isRequired,
    onSaveClick: PropTypes.func.isRequired, // DOpo il salvataggio. Argomenti: attivita - attività salvata sul db
}

export default AttivitaForm;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaForm.jsx
 **/